import { INTERAX_COLORS, INTERAX_TYPOGRAPHY } from '../../../../constants/colors'

export const LEADER_SCOPE_MODAL_MAX_WIDTH = '620px'
export const LEADER_SCOPE_LIST_MAX_HEIGHT_PX = 320
export const LEADER_SCOPE_LIST_MIN_HEIGHT_PX = 112 // two people
const LEADER_SCOPE_MODAL_FRAME_HEIGHT_PX = 96 // the modal's padding (2 × 32) and the margin around it (2 × 16)
export const LEADER_SCOPE_GROUP_PICKER_MIN_WIDTH_PX = 180

// The content may use the screen minus the modal's own frame, and scrolls only if even that is too little.
export const leaderScopeModalContentSx = {
  maxHeight: `calc(100vh - ${LEADER_SCOPE_MODAL_FRAME_HEIGHT_PX}px)`,
  overflowY: 'auto'
} as const

// On a short screen the list gives way first and scrolls, so the title and Save stay in view.
export const leaderScopeListSx = {
  flexShrink: 1,
  minHeight: LEADER_SCOPE_LIST_MIN_HEIGHT_PX,
  maxHeight: LEADER_SCOPE_LIST_MAX_HEIGHT_PX,
  overflowY: 'auto',
  pr: 0.5
} as const

// The close button of the modal sits over the top right corner, so the title keeps clear of it.
export const leaderScopeTitleSx = { ...INTERAX_TYPOGRAPHY.headline4, color: INTERAX_COLORS.white, pr: 5 } as const

export const leaderScopeBodyTextSx = { ...INTERAX_TYPOGRAPHY.body3, color: INTERAX_COLORS.white } as const

export const leaderScopeMutedTextSx = { ...INTERAX_TYPOGRAPHY.body3, color: INTERAX_COLORS.thunderGrey } as const

export const leaderScopeCaptionSx = { ...INTERAX_TYPOGRAPHY.body4, color: INTERAX_COLORS.thunderGrey } as const

export const leaderScopeErrorTextSx = { ...INTERAX_TYPOGRAPHY.body3, color: INTERAX_COLORS.redError } as const

export const leaderScopePersonRowSx = {
  px: 1,
  borderRadius: '8px',
  cursor: 'pointer',
  '&:hover': { backgroundColor: INTERAX_COLORS.white04 }
} as const

export const leaderScopeCheckboxSx = {
  color: INTERAX_COLORS.thunderGrey,
  '&.Mui-checked': { color: INTERAX_COLORS.sun }
} as const

export const leaderScopeGroupPickerSx = {
  minWidth: LEADER_SCOPE_GROUP_PICKER_MIN_WIDTH_PX,
  color: INTERAX_COLORS.white,
  '.MuiOutlinedInput-notchedOutline': { borderColor: INTERAX_COLORS.white10 },
  '.MuiSvgIcon-root': { color: INTERAX_COLORS.white70 }
} as const
